import { render, staticRenderFns } from "./complaintStatistics.vue?vue&type=template&id=3762ff33&scoped=true"
import script from "./complaintStatistics.vue?vue&type=script&lang=js"
export * from "./complaintStatistics.vue?vue&type=script&lang=js"
import style0 from "./complaintStatistics.vue?vue&type=style&index=0&id=3762ff33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3762ff33",
  null
  
)

export default component.exports